//taken from https://auth0.com/docs/quickstart/spa/vuejs

import Vue from "vue";
import axios from 'axios';

import createAuth0Client from "@auth0/auth0-spa-js";
import EventEmitter from "events";

/** Define a default action to perform after authentication */
const DEFAULT_REDIRECT_CALLBACK = () =>
   window.history.replaceState({}, document.title, window.location.pathname);

let instance;

/** Returns the current instance of the SDK */
export const getInstance = () => instance;

/** Creates an instance of the Auth0 SDK. If one has already been created, it returns that instance */
export const useAuth0 = ({
                            onRedirectCallback = DEFAULT_REDIRECT_CALLBACK,
                            redirectUri = window.location.origin,
                            ...options
                         }) => {
   if (instance) return instance;

   // The 'instance' is simply a Vue object
   instance = new Vue({
      data() {
         return {
            loading: true,
            isAuthenticated: false,
            user: {},
            profile: {},
            auth0Client: null,
            popupOpen: false,
            error: null,
            requested_url: undefined,

         };
      },
      methods: {


         //helper fn which an object that can be passed to directly to axios
         //e.g. axios.get('http://localhost:3600/', getAxiosHeader() );
         async getAxiosHeader(){

            const token0 = await this.getTokenSilently();

            let token = {
               headers: {
                  Authorization: `Bearer ${token0}`,    // send the access token through the 'Authorization' header
                  "user-id": this.profile.user_id,
                  "user-email": this.profile.email
               }
            };

            return token;

         },

         //just returns the raw auth token, useful to get the current token to use in postman
         async getToken(){
            return await this.getTokenSilently();
         },

         /**
          * creates a profile object with our our own normalized naming system
          * Notes, this function assumes this.user has been defined
          */

         update_profile(){
            if (!this.isAuthenticated ) {
               this.profile = {};
               return;
            }


            let app_metadata =  this.user['https://taskteacher.dealerknows.com/app_metadata'];

            this.profile = {
               email: this.user.email,
               name: this.user.name,
               user_id: this.user.sub,
               picture: this.user.picture,
               app_metadata: this.user['https://taskteacher.dealerknows.com/app_metadata'],
               acct_type: app_metadata.acct_type,
               user_role: app_metadata.role,
               agency_id: app_metadata.agency_id,
               org_ids: app_metadata.org_ids,
               dealer_ids:  app_metadata.dealership_ids,
               // user_metadata: this.user['https://taskteacher.dealerknows.com/user_metadata'],
            };
         },




         /** Authenticates the user using a popup window */
         async loginWithPopup(o) {
            this.popupOpen = true;

            try {
               await this.auth0Client.loginWithPopup(o);
            } catch (e) {
               // eslint-disable-next-line
               console.error(e);
            } finally {
               this.popupOpen = false;
            }

            this.user = await this.auth0Client.getUser();
            this.update_profile();

            this.isAuthenticated = true;
         },
         /** Handles the callback when logging in using a redirect */
         async handleRedirectCallback() {
            this.loading = true;
            try {
               await this.auth0Client.handleRedirectCallback();
               this.user = await this.auth0Client.getUser();
               this.isAuthenticated = true;
            } catch (e) {
               this.error = e;
            } finally {
               this.loading = false;
            }
         },
         /** Authenticates the user using the redirect method */
         loginWithRedirect(o) {
            return this.auth0Client.loginWithRedirect(o);
         },
         /** Returns all the claims present in the ID token */
         getIdTokenClaims(o) {
            return this.auth0Client.getIdTokenClaims(o);
         },
         /** Returns the access token. If the token is invalid or missing, a new one is retrieved */
         getTokenSilently(o) {
            return this.auth0Client.getTokenSilently(o);
         },
         /** Gets the access token using a popup window */

         getTokenWithPopup(o) {
            return this.auth0Client.getTokenWithPopup(o);
         },
         /** Logs the user out and removes their session on the authorization server */
         logout(o) {
            o = {returnTo: `${window.location.origin}/`};
            return this.auth0Client.logout(o);
         },

         redirect(){
            if (this.requested_url != null){
               onRedirectCallback(this.requested_url);
            }
            else{
               this.requested_url = null;

            }
         },

         get_redirect(){
            let tmp = this.requested_url;
            if (tmp != null){
               this.requested_url = null;
            }
            return tmp;
         },


      },
      /** Use this lifecycle method to instantiate the SDK client */
      async created() {


         // Create a new instance of the SDK client using members of the given options object
         this.auth0Client = await createAuth0Client({
            domain: options.domain,
            client_id: options.clientId,
            audience: options.audience,
            redirect_uri: redirectUri
         });


         try {
            // If the user is returning to the app after authentication..
            if (
               window.location.search.includes("code=") &&
               window.location.search.includes("state=")
            ) {
               // handle the redirect and retrieve tokens
               const { appState } = await this.auth0Client.handleRedirectCallback();
               this.requested_url = appState;

               // Notify subscribers that the redirect callback has happened, passing the appState
               // (useful for retrieving any pre-authentication state)
               onRedirectCallback(appState);

            }

         } catch (e) {
            this.error = e;
         } finally {
            // Initialize our internal authentication state
            this.isAuthenticated = await this.auth0Client.isAuthenticated();
            this.user = await this.auth0Client.getUser();
            this.update_profile();
            this.loading = false;
            this.$emit('done-loading');
         }
      }
   });

   return instance;
};




// class AuthService extends EventEmitter {
//
//    constructor(){
//       super();
//       this.loading = true;
//       this.isAuthenticated=false;
//       this.user={};
//       this.profile= {};
//       this.auth0Client = null;
//       this.popupOpen = false;
//       this.error = null;
//       this.requested_url = undefined;
//    }
//
//    async init({redirectUri = window.location.origin +'/auth-callback', ...options}) {
//
//       // Create a new instance of the SDK client using members of the given options object
//       this.auth0Client = await createAuth0Client({
//          domain: options.domain,
//          client_id: options.clientId,
//          audience: options.audience,
//          redirect_uri: redirectUri
//       });
//
//
//       try {
//          // If the user is returning to the app after authentication..
//          if (
//             window.location.search.includes("code=") &&
//             window.location.search.includes("state=")
//          ) {
//             // handle the redirect and retrieve tokens
//             const { appState } = await this.auth0Client.handleRedirectCallback();
//             this.requested_url = appState;
//
//             // Notify subscribers that the redirect callback has happened, passing the appState
//             // (useful for retrieving any pre-authentication state)
//             // onRedirectCallback(appState);
//             // this is being called from the auth-callback now.
//          }
//          // else if (window.location.pathname !== '/auth-callback'){
//          //    console.log('url current', window.location.pathname);
//          //    this.requested_url = window.location.pathname;
//          //    window.location.replace(redirectUri);
//          // }
//       } catch (e) {
//          this.error = e;
//       } finally {
//          // Initialize our internal authentication state
//          this.isAuthenticated = await this.auth0Client.isAuthenticated();
//          this.user = await this.auth0Client.getUser();
//          this.update_profile();
//          this.loading = false;
//          this.emit('done-loading');
//       }
//    }//init()
//
//
//
//
//
//
//
//    //helper fn which an object that can be passed to directly to axios
//    //e.g. axios.get('http://localhost:3600/', getAxiosHeader() );
//    async getAxiosHeader(){
//
//       const token0 = await this.getTokenSilently();
//
//       let token = {
//          headers: {
//             Authorization: `Bearer ${token0}`,    // send the access token through the 'Authorization' header
//             "user-id": this.profile.user_id
//          }
//       };
//
//       return token;
//
//    }
//
//    /**
//     * creates a profile object with our our own normalized naming system
//     * Notes, this function assumes this.user has been defined
//     */
//
//    update_profile(){
//       if (!this.isAuthenticated ) {
//          this.profile = {};
//          return;
//       }
//
//
//       let app_metadata =  this.user['https://taskteacher.dealerknows.com/app_metadata'];
//
//       this.profile = {
//          email: this.user.email,
//          name: this.user.name,
//          user_id: this.user.sub,
//          picture: this.user.picture,
//          app_metadata: this.user['https://taskteacher.dealerknows.com/app_metadata'],
//          acct_type: app_metadata.acct_type,
//          user_role: app_metadata.role,
//          agency_id: app_metadata.agency_id,
//          org_ids: app_metadata.org_ids,
//          dealer_ids:  app_metadata.dealership_ids,
//          // user_metadata: this.user['https://taskteacher.dealerknows.com/user_metadata'],
//       };
//    }
//
//
//
//
//    /** Authenticates the user using a popup window */
//    async loginWithPopup(o) {
//       this.popupOpen = true;
//
//       try {
//          await this.auth0Client.loginWithPopup(o);
//       } catch (e) {
//          // eslint-disable-next-line
//          console.error(e);
//       } finally {
//          this.popupOpen = false;
//       }
//
//       this.user = await this.auth0Client.getUser();
//       this.update_profile();
//
//       this.isAuthenticated = true;
//    }
//    /** Handles the callback when logging in using a redirect */
//    async handleRedirectCallback() {
//       this.loading = true;
//       try {
//          await this.auth0Client.handleRedirectCallback();
//          this.user = await this.auth0Client.getUser();
//          this.isAuthenticated = true;
//       } catch (e) {
//          this.error = e;
//       } finally {
//          this.loading = false;
//       }
//    }
//    /** Authenticates the user using the redirect method */
//    loginWithRedirect(o) {
//       return this.auth0Client.loginWithRedirect(o);
//    }
//    /** Returns all the claims present in the ID token */
//    getIdTokenClaims(o) {
//       return this.auth0Client.getIdTokenClaims(o);
//    }
//    /** Returns the access token. If the token is invalid or missing, a new one is retrieved */
//    getTokenSilently(o) {
//       return this.auth0Client.getTokenSilently(o);
//    }
//    /** Gets the access token using a popup window */
//
//    getTokenWithPopup(o) {
//       return this.auth0Client.getTokenWithPopup(o);
//    }
//    /** Logs the user out and removes their session on the authorization server */
//    logout(o) {
//       return this.auth0Client.logout(o);
//    }
//
// }//AuthService
// instance = new AuthService();



// Create a simple Vue plugin to expose the wrapper object throughout the application
export const Auth0Plugin = {
   install(Vue, options) {
      Vue.prototype.$auth = useAuth0(options);
      // Vue.prototype.$auth = instance;
      // Vue.prototype.$auth.init(options)





   }
};
